import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';



export function keyValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if(!control.value){
      return null;
    }
    if(control.value.length != 26){
      return {'appTrueKey': {value: control.value}};
    }
    let keyP:string = control.value;
    keyP = keyP.split("").sort().join("");
    if (keyP != "ABCDEFGHIJKLMNOPQRSTUVWXYZ"){
      return {'appTrueKey': {value: control.value}};
    }
    return null;
    
  };
}

@Directive({
  selector: '[appTrueKey]',
  providers: [{provide: NG_VALIDATORS, useExisting: TrueKeyDirective, multi: true}]
})
export class TrueKeyDirective implements Validator{

  @Input('appTrueKey') trueKey: string;


  validate(control: AbstractControl): {[key: string]: any} {
    return  keyValidator()(control);
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('trueKey' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

  

}
